var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11L9.5 11M27.5 2L9.5 2M27.5 20L9.5 20M3.5 11C3.5 11.8284 2.82843 12.5 2 12.5C1.17157 12.5 0.5 11.8284 0.5 11C0.5 10.1716 1.17157 9.5 2 9.5C2.82843 9.5 3.5 10.1716 3.5 11ZM3.5 2C3.5 2.82843 2.82843 3.5 2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2ZM3.5 20C3.5 20.8284 2.82843 21.5 2 21.5C1.17157 21.5 0.5 20.8284 0.5 20C0.5 19.1716 1.17157 18.5 2 18.5C2.82843 18.5 3.5 19.1716 3.5 20Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.5554f725fecec2b9212779b101e132d3.svg";
export { ForwardRef as ReactComponent };